export default __webpack_public_path__ + "c87fdef6c5cd96bf1fde8ad45789089c.png";